import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=fcb86810&scoped=true&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=fcb86810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb86810",
  null
  
)

export default component.exports